// extracted by mini-css-extract-plugin
export default {"placeholder":"Kq6pQORw","mobile":"mobile","content":"PVchgCkZ","emoji":"b1rVM9OM"};